import { useGetUserQuery } from "../../utils/user.utils";
import { useParams } from "react-router-dom";
import PageLayout from "../../layouts/PageLayout";
import { textStarCase } from "../../utils/string.utils";
import { RightDoubleArrowIcon } from "../../utils/icon.utils";
import { arrayMap } from "../../utils/array.utils";

export default function ProfilePage() {
  const { username } = useParams();
  const { data: user, loading } = useGetUserQuery({
    username
  });

  if (loading) {
    return "Loading...";
  }

  const breadCrumbs = [
    {
      name: "Profile",
      link: `/user/${user?.username ?? ""}/profile`
    },
    {
      name: user?.name ?? ""
    }
  ];

  const permissions = user?.permissions ? Object.entries(user?.permissions) : [];

  return (
    <PageLayout title="Profile" breadCrumbs={breadCrumbs}>
      <ul>
        <li>
          <b>Name</b>: {user?.name ?? "-"}
        </li>
        <li>
          <b>Username</b>: {user?.username ?? "-"}
        </li>
        <li>
          <b>Email</b>: {user?.email ?? "-"}
        </li>
        <li>
          <b>Role</b>: {user?.role?.name ?? "-"}
        </li>
        <li>
          <b>Permissions</b>:{" "}
          {arrayMap(permissions, (item, index) => {
            const sl = index + 1;
            return (
              <div key={sl}>
                <p>
                  {sl}. {textStarCase(item[0])} <RightDoubleArrowIcon /> {item[1]?.join(", ")}
                </p>
              </div>
            );
          })}
        </li>
      </ul>
    </PageLayout>
  );
}
